export default "__VITE_ASSET__46f86cf3__"